import React from 'react';
import { cn } from '@/lib/utils';
import { Textarea } from '@/components/ui/textarea';

interface TextAreaFieldProps {
  className: string;
  text?: string;
  inputValue: string;
  placeholderText: string;
  state?: 'default';
  type?: string;
  disabled?: boolean;
  rows?: number;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: () => void;
}

export const TextAreaField: React.FC<TextAreaFieldProps> = ({
  className,
  text,
  inputValue = 'This is a bold title',
  placeholderText = '',
  disabled = false,
  rows,
  onChange,
  onBlur,
}) => {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {text && <p className="text-button-sm font-medium text-neutral-500">{text}</p>}

      <Textarea
        className={cn('max-h-40 min-h-16 w-full resize-none resize-y', {
          'cursor-not-allowed': disabled === true,
        })}
        placeholder={placeholderText}
        value={inputValue}
        disabled={disabled}
        rows={rows}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={(e) => e.stopPropagation()}
      />
    </div>
  );
};
